import type { VehiclesEnrollmentViewRequestDto } from '~/api/generated-api';
import { ENROLLMENT_VIEWS } from '~/features/integrations/partners/types';

export type EnrollmentStatus =
  VehiclesEnrollmentViewRequestDto['enrollmentStatuses'][number];

/**
 * The statuses each status tab requests. A tab id missing here has no table, because an empty
 * `enrollmentStatuses` list asks the API for every status.
 */
export const ENROLLMENT_VIEW_STATUSES: Partial<
  Record<string, EnrollmentStatus[]>
> = {
  [ENROLLMENT_VIEWS.ENROLLED]: ['ENROLLED'],
  [ENROLLMENT_VIEWS.ERRORS]: ['ERROR_ENROLLMENT', 'ERROR_UNENROLLMENT'],
  [ENROLLMENT_VIEWS.PENDING]: ['PENDING_ENROLL', 'PENDING_UNENROLL'],
};

export const ENROLLMENT_TABLE_PAGE_SIZE = 10;
